import Vue from "vue";
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

for (const [rule, validation] of Object.entries(rules)) {
    extend(rule, {
        ...validation,
    });
}

extend("required_relation", {
    validate: (value: any) => value && value > 0,
    message: field => `The ${field} field cannot be empty.`,
});

extend("url_validate", {
    validate: (value: string) => value && /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value),
    message: field => `The  ${field} must be a valid URL`,
});

localize({
    en,
});
localize("en");
